// eslint-disable-next-line no-use-before-define
import React, { useState, useContext } from 'react'
import MaterialDrawer from '@material-ui/core/Drawer'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'
import SvgIcon from '@material-ui/core/SvgIcon'
import PersonIcon from '@material-ui/icons/Person'
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import LinkIcon from '@material-ui/icons/Link'
import StoreIcon from '@material-ui/icons/Store'
import ReceiptIcon from '@material-ui/icons/Receipt'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import CardMembershipIcon from '@material-ui/icons/CardMembership'
import NotificationsIcon from '@material-ui/icons/Notifications'
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents'
import LoyaltyIcon from '@material-ui/icons/Loyalty'
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive'
import { NavLink } from 'react-router-dom'
import DashboardIcon from '@material-ui/icons/Dashboard'
import AssignmentIcon from '@material-ui/icons/Assignment'
import StylesIcon from '@material-ui/icons/Style'
import StarRateIcon from '@material-ui/icons/StarRate'

import { ReactComponent as AutomationSvg } from 'assets/icons/automatic.svg'
import LoyaleatLogo from 'assets/images/Loyaleat_logo2.png'
import { Version } from 'components/Version'
import { UserContext } from 'contexts'
import { ConfigUtils } from 'utils/config'
import { hasModuleAccess } from 'utils/roles'
import { Admin } from 'features/Main/Admins/types'

import { useStyles } from './styles'
import packageJson from '../../../package.json'

const { version } = packageJson

interface Path {
  pathname: string
  search?: string
  hash?: string
  state?: Record<string, unknown>
}

interface Items {
  label: string
  link?: string | Path
  icon?: typeof SvgIcon
}

interface DrawerOption {
  label: string
  link?: string | Path
  icon: typeof SvgIcon
  items?: Items[]
  showCondition: boolean
}

const AutomationIcon = () => (
  <SvgIcon>
    <AutomationSvg />
  </SvgIcon>
)

console.log('process.env.NODE_ENV', process.env.NODE_ENV)

const appName = process.env.REACT_APP_NAME?.toLowerCase() ?? ''

const showNewDashboard: Record<string, boolean> = {
  tea: true,
  ge: true,
  cs: true,
  'le-pain-quotidien': true,
  paru: true,
  jb: true,
  ts: true,
  cm: true,
  ronnie: true,
  'signora-mariola': true,
  vicolo: true,
  'acai-brasil': true,
  'la-condesa': true,
  'el-diez': true,
}

const getDrawerOptions = (admin: Admin | undefined): DrawerOption[] => [
  {
    label: 'Analytics',
    link: {
      pathname: '/new-dashboard',
    },
    icon: DashboardIcon,
    showCondition: showNewDashboard[appName] && hasModuleAccess(admin, 'analytics'),
  },
  {
    label: 'Campañas',
    link: {
      pathname: '/campaigns',
    },
    icon: NotificationsActiveIcon,
    showCondition: hasModuleAccess(admin, 'campaigns'),
  },
  {
    label: 'Loyalty',
    link: {
      pathname: '/loyalty',
    },
    icon: CardMembershipIcon,
    showCondition: hasModuleAccess(admin, 'loyalty'),
  },
  {
    label: 'Automation',
    link: {
      pathname: '/notificaciones/automaticas',
    },
    icon: AutomationIcon,
    showCondition: hasModuleAccess(admin, 'automation'),
  },
  {
    label: 'Tags',
    link: {
      pathname: '/tags',
    },
    icon: LoyaltyIcon,
    showCondition: hasModuleAccess(admin, 'tags'),
  },
  {
    label: 'Configuraciones',
    link: {
      pathname: '/configuraciones',
    },
    icon: StylesIcon,
    showCondition: hasModuleAccess(admin, 'configuraciones'),
  },
  {
    label: 'Reviews',
    link: {
      pathname: '/reviews',
    },
    icon: StarRateIcon,
    showCondition: ConfigUtils.reviews.enabled && hasModuleAccess(admin, 'reviews'),
  },
  {
    label: 'Usuarios',
    link: '/users',
    icon: PersonIcon,
    showCondition: false,
  },
  {
    label: 'Links mobile',
    link: {
      pathname: '/drawer-items',
    },
    icon: LinkIcon,
    showCondition: false,
  },
  {
    label: 'Locales',
    link: {
      pathname: '/stores',
    },
    icon: StoreIcon,
    showCondition: false,
  },
  {
    label: 'Promos',
    link: {
      pathname: '/coupons',
    },
    icon: ReceiptIcon,
    showCondition: false,
  },
  {
    label: 'Rewards manuales',
    link: {
      pathname: '/rewards-manuales',
    },
    icon: EmojiEventsIcon,
    showCondition: false,
  },
  {
    label: 'Push notification',
    link: {
      pathname: '/notifications',
    },
    icon: NotificationsIcon,
    showCondition: false,
  },
  {
    label: 'User Test',
    link: {
      pathname: '/user-test',
    },
    icon: AssignmentIcon,
    showCondition: false,
  },
  {
    label: 'Administradores',
    link: {
      pathname: '/admins',
    },
    icon: SupervisorAccountIcon,
    showCondition: false,
  },
  {
    label: 'Descargas',
    link: {
      pathname: '/downloads',
    },
    icon: ArrowDownward,
    showCondition: false,
  },
  {
    label: 'Dashboard',
    link: {
      pathname: '/dashboard',
    },
    icon: DashboardIcon,
    showCondition: false,
  },
  {
    label: 'Config. de estilo',
    link: {
      pathname: '/styles',
    },
    icon: StylesIcon,
    showCondition: false,
  },
]

const Drawer: React.FC = () => {
  const classes = useStyles()
  const { admin } = useContext(UserContext)
  const [isExpanded, setIsExpanded] = useState(false)

  const handleMouseEnter = () => {
    setIsExpanded(true)
  }

  const handleMouseLeave = () => {
    setIsExpanded(false)
  }

  const drawerOptions = getDrawerOptions(admin)

  return (
    <MaterialDrawer
      variant="permanent"
      className={`${classes.drawer} ${!isExpanded ? classes.drawerCollapsed : ''}`}
      classes={{
        paper: `${classes.drawerPaper} ${!isExpanded ? classes.drawerPaperCollapsed : ''}`,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={classes.toolbar} />
      <List className={classes.list}>
        {drawerOptions
          .filter(e => e.showCondition)
          .map(option => (
            <NavLink
              to={option.link || ''}
              className={({ isActive }) => (isActive ? classes.activeLink : classes.link)}
              key={option.label}
            >
              <ListItem button>
                <ListItemIcon className={!isExpanded ? classes.icon : ''}>
                  <option.icon />
                </ListItemIcon>
                {isExpanded && <ListItemText primary={option.label} />}
              </ListItem>
            </NavLink>
          ))}
      </List>

      {/* Logo y Cerrar sesión en la parte inferior */}
      <div className={classes.bottomSection}>
        {isExpanded && (
          <>
            <div className={classes.logoContainer}>
              <img src={LoyaleatLogo} alt="Loyaleat" className={classes.logo} />
            </div>
            {/* <ListItem button onClick={handleLogout} className={classes.logoutButton}>
              <ListItemText
                primary="CERRAR SESIÓN"
                primaryTypographyProps={{
                  style: {
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: 12,
                    fontWeight: 500,
                    color: '#666',
                    textAlign: 'center',
                  },
                }}
              />
            </ListItem> */}
            <Version version={version} />
          </>
        )}
      </div>
    </MaterialDrawer>
  )
}

export { Drawer }
